export const FINANCIAL_DISCLAIMER_HEADING =
  'THIS SOFTWARE IS NOT A FINANCIAL ADVISOR, PLANNER, OR FIDUCIARY.';

export const FINANCIAL_DISCLAIMER_POINTS = [
  'lynx-crypto and all associated trading strategies, signals, backtests, and paper trading simulations are provided strictly for educational and research purposes.',
  'The system is not responsible for any financial losses incurred by users who choose to act on signals, strategies, or data produced by this platform.',
  'Past performance, whether backtested or paper-traded, does not guarantee future results.',
  'Cryptocurrency markets are highly volatile and speculative. Never invest more than you can afford to lose.',
  'This system does not constitute investment advice. Consult a licensed financial advisor before making investment decisions.',
  'By using this system, you accept full responsibility for your own trading decisions and outcomes.',
] as const;

export const FINANCIAL_DISCLAIMER_SUMMARY =
  'Educational and research use only. This platform does not provide investment advice.';

export const STRATEGY_ACTIVATION_CONFIRMATION = [
  FINANCIAL_DISCLAIMER_HEADING,
  '',
  'Activating a strategy for paper or live workflows is your responsibility.',
  'Past performance does not guarantee future results.',
  '',
  'Do you want to continue?',
].join('\n');
